import { SheetLevel } from './types';

// Default geometry. `breakpoint` decides when the bottom-sheet behavior
// activates (below ⇒ mobile sheet, above ⇒ desktop static list).
export const DEFAULT_BREAKPOINT = 960;
export const DEFAULT_TOP_CHROME = 125;

// Snap animation cadence. `quart` (4th power) eases more gently than
// cubic near the settle point — Apple/Airbnb-ish deceleration.
export const SNAP_DURATION_MS = 320;

// Closing from fully-open (CLOSED) toward a smaller level uses a softer, longer
// deceleration than a normal snap — `septic` (7th power) over a longer duration.
export const CLOSE_FROM_FULLY_OPEN_DURATION_MS = 480;

// v3: duracao do arme GRADUAL da barreira (spacer + scroll juntos). O arme
// instantaneo fazia a barra de URL do iOS animar de uma vez (re-composite ->
// pisca das sobreposicoes); espalhando o mesmo deslocamento de scroll por essa
// janela, a barra se move de forma continua como num scroll do usuario.
export const BARRIER_ARM_DURATION_MS = 300;

// Fallback when `scrollend` isn't available (older Safari): we treat
// 140ms of scroll quiescence as the end of a gesture.
// Tempo minimo que considera scroll parado para recalc de geometria e outros
// ajustes. No iOS com scroll super rapido, a inercia pode durar 800-1200ms,
// entao 140ms era insuficiente e causava race com mudanca de maxOffset.
// Aumentado para 800ms para cobrir momentum scroll super vigoroso.
export const SCROLL_IDLE_MS = 800;

// Resolution at which we consider scrollY "exactly on" a snap.
export const SNAP_RESTING_PX = 3;

// Sub-pixel threshold below which a snap is committed instantly (no animation).
export const MIN_SNAP_DELTA_PX = 1;

// Movement below this on the handle is treated as a tap, not a drag.
export const HANDLE_DRAG_TAP_THRESHOLD_PX = 3;

// After a real drag, swallow the synthetic `click` for this window so
// the CTA doesn't immediately snap us back to FULLY_OPEN.
export const HANDLE_CLICK_GUARD_MS = 220;

export const HEADER_REVEAL_THRESHOLD_PX = 80;

// Fraction of the gap to the next snap that a gesture must travel, in its
// direction, to commit to that next snap. Same rule for handle drag and list
// scroll: direction wins, and ~15% of progress is enough to advance.
export const SNAP_DIRECTION_PROGRESS_RATIO = 0.15;

export const LIST_SCROLL_START_BUFFER_PX = 5;

// Atributo que marca, no conteudo da lista, o limite inferior da area de drag no
// half-open (ate o fim do primeiro card). O composable so conhece esse nome; a
// lista decide onde aplica-lo. Constante unica para os dois lados nao
// dessincronizarem.
export const BOTTOM_SHEET_DRAG_ZONE_ATTR = 'data-bottom-sheet-drag-zone';

// Canonical level ordering for any "iterate over all snaps" operation.
export const SNAP_LEVELS = [
	SheetLevel.FULLY_OPEN,
	SheetLevel.HALF_OPEN,
	SheetLevel.CLOSED
] as const;

// Step-back map: each level's "previous" (closer to FULLY_OPEN).
export const PREVIOUS_LEVEL: Partial<Record<SheetLevel, SheetLevel>> = {
	[SheetLevel.CLOSED]: SheetLevel.HALF_OPEN,
	[SheetLevel.HALF_OPEN]: SheetLevel.FULLY_OPEN
};

export function easeOutCubic(t: number): number {
	return 1 - Math.pow(1 - t, 3);
}

export function easeOutQuart(t: number): number {
	return 1 - Math.pow(1 - t, 4);
}

export function easeOutSeptic(t: number): number {
	return 1 - Math.pow(1 - t, 7);
}
